import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const QcConfigSection = styled.div`
    display: flex;
    width: 600px;
    flex-direction: column;
    gap: 1rem;
`;

export const QcConfigSectionHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const QcConfigSectionSubtitle = styled.div`
    color: ${owcTheme['one-color-gray-600']};
`;

export const QcConfigError = styled.span`
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${owcTheme['one-color-red-400']};
`;

export const QcConfigList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
`;
